module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "icon-demo",
    attrs: {
      "title": "Icon"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "singleDate",
      "description": "单日期选择",
      "code": _vm.single_date,
      "lang": "js"
    }
  }, [_c('div', [_vm._v("日期: " + _vm._s(_vm.demo_single_date))]), _vm._v(" "), _c('div', {
    staticClass: "calendar-warp"
  }, [_c('vCalendar', {
    attrs: {
      "is_show": true,
      "is_range": false,
      "is_single_month": true,
      "is_today_disable": true
    },
    on: {
      "get-first-value": function($event) {
        _vm.demo_single_date = arguments[0]
      }
    }
  })], 1)]), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "doubleDate",
      "description": "双日期选择",
      "code": _vm.double_date,
      "lang": "js"
    }
  }, [_c('div', [_vm._v("起止日期:  " + _vm._s(_vm.demo_from_date) + " "), _c('Icon', {
    attrs: {
      "name": "arrowright"
    }
  }), _vm._v(" " + _vm._s(_vm.demo_ret_date))], 1), _vm._v(" "), _c('div', {
    staticClass: "calendar-warp"
  }, [_c('vCalendar', {
    attrs: {
      "is_show": true,
      "is_range": true,
      "is_single_month": true,
      "is_today_disable": true
    },
    on: {
      "get-first-value": function($event) {
        _vm.demo_from_date = arguments[0]
      },
      "get-sec-value": function($event) {
        _vm.demo_ret_date = arguments[0]
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20a99e92"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Calendar.vue
// module id = 622
// module chunks = 0